//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "index",
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    toTopic: function toTopic() {
      this.$router.push({
        name: 'topic'
      });
    }
  }
};